import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import ui from '../services/ui';

class TermsDropdown extends Component {
	render() {
		const { id = 'termsDropdown', terms, selectedTerm, t } = this.props;
		const sortedTerms = terms.sort(function (a, b) {
			return moment(a.startDate).format('YYYYMMDD') - moment(b.startDate).format('YYYYMMDD');
		});
		const selectedTermDisplayName = selectedTerm ? `${selectedTerm.name} (${ui.formatDayMonth(selectedTerm.startDate)} - ${ui.formatDayMonth(selectedTerm.endDate)})` : '';

		return <DropdownButton id={id} onSelect={key => this.props.onSelectTerm(key)}
			className='btn-block-xxs'
			bsStyle={selectedTerm ? 'primary' : 'default'}
			title={selectedTerm ? selectedTermDisplayName : t('FO_TimetableSearch_Term')}
		>
			{sortedTerms.map(term => <MenuItem key={term.id} eventKey={term.id}>{term.name} ({ui.formatDayMonth(term.startDate)} - {ui.formatDayMonth(term.endDate)})</MenuItem>)}
		</DropdownButton>;
	}
}

TermsDropdown.propTypes = {
	terms: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string,
		startDate: PropTypes.string,
		endDate: PropTypes.string
	})),
	selectedTerm: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string,
		startDate: PropTypes.string,
		endDate: PropTypes.string
	}),
	onSelectTerm: PropTypes.func.isRequired
};

export default withTranslation()(TermsDropdown);